import { render, staticRenderFns } from "./maintenance.vue?vue&type=template&id=d40833f2&scoped=true"
var script = {}
import style0 from "./maintenance.vue?vue&type=style&index=0&id=d40833f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_eaa621c2599a96d5b6a0fac765048019/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d40833f2",
  null
  
)

export default component.exports